import {Pipe, PipeTransform} from "@angular/core"
@Pipe({name: 'invoicesearchfilter'})
export class InvoiceSearchPipe implements PipeTransform {
    transform(value:any,  [ordernumber, invoicenumber]):any{

         //See all Threads
         if(ordernumber == 0 && invoicenumber == 0) {
            return value;
          }
          //See selected Units only
          if(ordernumber != 0 && invoicenumber == 0){
            return value.filter(thread  => {
              return thread.ordernumber === ordernumber;
            });
          }
          //See selected Units and Tasks
          if (ordernumber != 0 && invoicenumber != 0){
            return value.filter(thread => {
              return thread.ordernumber === ordernumber && thread.invoicenumber === invoicenumber;
            });
        }
       
        }
}





// WEBPACK FOOTER //
// ./src/app/providers/invoicesearchpipe.ts